import React from 'react';
import WidePage from '../../Layouts/WidePage';
import ShowLatestCart from './ShowLatestCart';
import IfLoggedIn from '../../Components/IfLoggedIn';
import IfLoggedOut from '../../Components/IfLoggedOut';
import { Redirect } from 'react-router-dom';

function MyCart(props) {
  return (
    <>
      <IfLoggedOut>
        <Redirect to="/login?redirect=/my-cart" />
      </IfLoggedOut>
      <IfLoggedIn>
        <WidePage title="Cart">
          <ShowLatestCart />
        </WidePage>
      </IfLoggedIn>
    </>
  );
}

export default MyCart;
